/**
 * Email Service
 *
 * These functions call Firebase Cloud Functions (or your own backend API)
 * to trigger transactional emails via SendGrid / Nodemailer.
 *
 * SETUP:
 * 1. Deploy Firebase Cloud Functions (see /functions directory)
 * 2. Install SendGrid: npm install @sendgrid/mail
 * 3. Set SENDGRID_API_KEY in Firebase environment config
 * 4. Set REACT_APP_FUNCTIONS_BASE_URL in your .env file
 *
 * Or replace FUNCTIONS_BASE_URL with your own API endpoint.
 */

const FUNCTIONS_BASE_URL =
  process.env.REACT_APP_FUNCTIONS_BASE_URL || 'https://YOUR_REGION-YOUR_PROJECT.cloudfunctions.net';

const post = async (endpoint, body) => {
  const res = await fetch(`${FUNCTIONS_BASE_URL}/${endpoint}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`Email API error: ${res.status}`);
  return res.json();
};

export const sendBookingConfirmation = async ({ to, name, bookingId, spaceName, seatName, startDate, endDate, price, pricingType, paymentMethod, bsb, accountNumber, accountName }) => {
  return post('sendBookingConfirmation', { to, name, bookingId, spaceName, seatName, startDate, endDate, price, pricingType, paymentMethod, bsb, accountNumber, accountName });
};

export const sendAccessDetails = async ({ to, name, spaceName, accessCode, wifiPassword, address }) => {
  return post('sendAccessDetails', { to, name, spaceName, accessCode, wifiPassword, address });
};

export const sendContractReminder = async ({ to, name, signingUrl }) => {
  return post('sendContractReminder', { to, name, signingUrl });
};

export const sendWelcomeEmail = async ({ to, name }) => {
  return post('sendWelcomeEmail', { to, name });
};

export const sendCancellationEmail = async ({ to, name, bookingId, spaceName }) => {
  return post('sendCancellationEmail', { to, name, bookingId, spaceName });
};

export const sendSubMemberWelcome = async ({ to, name, memberName, spaceName, wifiSSID, wifiPassword }) => {
  return post('sendSubMemberWelcome', { to, name, memberName, spaceName, wifiSSID, wifiPassword });
};

export const sendPaymentLink = async ({ to, name, bookingId, spaceName, startDate, price, payUrl }) => {
  return post('sendPaymentLink', { to, name, bookingId, spaceName, startDate, price, payUrl });
};

export const sendRefundConfirmation = async ({ to, name, spaceName, startDate, price, refundType, creditNoteRef }) => {
  return post('sendRefundEmail', { to, name, spaceName, startDate, price, refundType, creditNoteRef });
};

export const sendAccessCodeNotification = async ({ to, name, phone, pin, spaceName, startDate, endDate, bookingId }) => {
  return post('sendAccessCodeNotification', { to, name, phone, pin, spaceName, startDate, endDate, bookingId });
};

export const sendSupportMessage = async ({ from, name, phone, category, subject, message }) => {
  return post('sendSupportMessage', { from, name, phone, category, subject, message });
};

export const generateInvoice = async (bookingId, { resend } = {}) => {
  return post('generateInvoice', { bookingId, resend });
};

export const generateCreditNote = async (bookingId) => {
  return post('generateCreditNote', { bookingId });
};
